import React from "react";
import { API_URL } from "../../config";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import { useAppContext } from "../../Lib/ContextLib";

export default function VerifiedPlayer({ rowValue }) {
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const { socket } = useAppContext();

  

  const LoginSchema = Yup.object().shape({
    kycStatus: Yup.number().required("Status is required"),
    kycFailReason: Yup.string().when("kycStatus", {
      is: 2, // Not Verified
      then: Yup.string().required("Reason is required when rejecting KYC"),
      otherwise: Yup.string(),
    }),
  });

  const successEditStatus = (msg) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          setAlert(null);
          setButtonLoader(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  const errorAlert = (msg) => {
    setAlert(
      <SweetAlert
        error
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          setAlert(null);
          setButtonLoader(false);
        }}
        confirmBtnBsStyle="danger"
      ></SweetAlert>
    );
  };

  const hasKycDocuments = () => {
    return (
      rowValue?.kycAdharCardNo ||
      rowValue?.kycPanCardNo ||
      rowValue?.kycLicenceNo ||
      rowValue?.kycAdharCardImageUrl ||
      rowValue?.kycPanCardImageUrl ||
      rowValue?.kycLicenceImageUrl
    );
  };

  return (
    <div>
      {alert}
      <Formik
        initialValues={{
          kycStatus: rowValue ? rowValue?.kycStatus : 3,
          kycFailReason: rowValue ? rowValue?.kycFailReason : "",
        }}
        validationSchema={LoginSchema}
        onSubmit={(values, { resetForm }) => {
          let merged = {
            kycFailReason: values?.kycFailReason,
            kycStatus: parseInt(values?.kycStatus),
          };

          setButtonLoader(true);
          axios(
            `${API_URL}/api/admin/player/update-kyc-details/${rowValue._id}`,
            {
              method: "POST",
              credentials: "include",
              data: merged,
            }
          )
            .then((result) => {
              if (result.data.status) {
                const data = {
                  playerId: rowValue.playerId,
                  message: "KYC Status Updated",
                };
                socket.emit("PlayerDetailsUpdate", data);
                successEditStatus(result.data.message);
                resetForm();
              } else {
                errorAlert(result.data.message || "Error updating KYC status");
                resetForm();
              }
            })
            .catch((err) => {
              setButtonLoader(false);
              errorAlert("Failed to update KYC status");
              console.error("handleSubmit err:", err);
            });
        }}
      >
        {({ touched, errors, isSubmitting, values }) => (
          <div>
            <Form>
              {!hasKycDocuments() && (
                <div className="alert alert-warning">
                  No KYC documents submitted by user
                </div>
              )}

              {rowValue?.kycLicenceNo && (
                <div className="form-group">
                  <label htmlFor="kycLicenceNo" className="mt-3">
                    Licence No
                  </label>
                  <Field
                    disabled
                    type="text"
                    name="kycLicenceNo"
                    value={rowValue?.kycLicenceNo}
                    placeholder="Licence Number"
                    className="form-control"
                  />
                </div>
              )}

              {rowValue?.kycAdharCardNo && (
                <div className="form-group">
                  <label htmlFor="kycAdharCardNo">Aadhar Card</label>
                  <Field
                    disabled
                    type="text"
                    name="kycAdharCardNo"
                    value={rowValue?.kycAdharCardNo}
                    placeholder="Aadhar Card Number"
                    className="form-control"
                  />
                </div>
              )}

              {rowValue?.kycPanCardNo && (
                <div className="form-group">
                  <label htmlFor="kycPanCardNo">Pancard No</label>
                  <Field
                    disabled
                    type="text"
                    name="kycPanCardNo"
                    value={rowValue?.kycPanCardNo}
                    placeholder="Pancard Number"
                    className="form-control"
                  />
                </div>
              )}

              <div className="row">
                {rowValue?.kycLicenceImageUrl ? (
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="licenceImage" className="mt-3">
                      Licence Image
                    </label>
                    <br />
                    <img
                      src={rowValue?.kycLicenceImageUrl}
                      alt="licence_image"
                      className="img-fluid border"
                      style={{ maxWidth: "100%", maxHeight: "300px" }}
                    />
                  </div>
                ) : null}

                {rowValue?.kycAdharCardImageUrl ? (
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="aadharImage" className="mt-3">
                      Aadhar Card Image
                    </label>
                    <br />
                    <img
                      src={rowValue?.kycAdharCardImageUrl}
                      alt="aadhar_image"
                      className="img-fluid border"
                      style={{ maxWidth: "100%", maxHeight: "300px" }}
                    />
                  </div>
                ) : null}

                {rowValue?.kycPanCardImageUrl ? (
                  <div className="col-sm-12 col-md-6 mt-3">
                    <label htmlFor="panImage">Pancard Image</label>
                    <br />
                    <img
                      src={rowValue?.kycPanCardImageUrl}
                      alt="pancard_image"
                      className="img-fluid border"
                      style={{ maxWidth: "100%", maxHeight: "300px" }}
                    />
                  </div>
                ) : null}
              </div>

              <div className="form-group mt-3">
                <label htmlFor="kycStatus">Status</label>
                <Field
                  as="select"
                  name="kycStatus"
                  className={`form-control ${
                    touched.kycStatus && errors.kycStatus ? "is-invalid" : ""
                  }`}
                >
                  <option value={0}>Pending</option>
                  <option value={1}>Verified</option>
                  <option value={2}>Not Verified</option>
                  <option value={3}>None</option>
                </Field>
                <ErrorMessage
                  component="div"
                  name="kycStatus"
                  className="invalid-feedback"
                />
              </div>

              {values.kycStatus === 2 && (
                <div className="form-group">
                  <label htmlFor="kycFailReason" className="mt-3">
                    KYC Rejection Reason
                  </label>
                  <Field
                    component="textarea"
                    name="kycFailReason"
                    rows={4}
                    placeholder="Enter rejection reason"
                    className={`form-control ${
                      touched.kycFailReason && errors.kycFailReason
                        ? "is-invalid"
                        : ""
                    }`}
                  />
                  <ErrorMessage
                    component="div"
                    name="kycFailReason"
                    className="invalid-feedback"
                  />
                </div>
              )}

              <button
                type="submit"
                className="btn btn-primary btn-block mt-4"
                disabled={buttonLoader}
                style={{ minWidth: "120px" }}
              >
                {buttonLoader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="ml-2">Processing...</span>
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
}
